{
  "version": "2.0",
  "generatedAt": "2026-09-28T05:48:15.887Z",
  "tactics": [
    { "id": "TA0043", "name": "Reconnaissance", "order": 0 },
    { "id": "TA0042", "name": "Resource Development", "order": 1 },
    { "id": "TA0001", "name": "Initial Access", "order": 2 },
    { "id": "TA0002", "name": "Execution", "order": 3 },
    { "id": "TA0003", "name": "Persistence", "order": 4 },
    { "id": "TA0004", "name": "Privilege Escalation", "order": 5 },
    { "id": "TA0005", "name": "Stealth", "order": 6 },
    { "id": "TA0112", "name": "Defense Impairment", "order": 7 },
    { "id": "TA0006", "name": "Credential Access", "order": 8 },
    { "id": "TA0007", "name": "Discovery", "order": 9 },
    { "id": "TA0008", "name": "Lateral Movement", "order": 10 },
    { "id": "TA0009", "name": "Collection", "order": 11 },
    { "id": "TA0011", "name": "Command and Control", "order": 12 },
    { "id": "TA0010", "name": "Exfiltration", "order": 13 },
    { "id": "TA0040", "name": "Impact", "order": 14 }
  ],
  "techniques": {
    "T1055.011": {
      "name": "Extra Window Memory Injection",
      "tactics": ["TA0005", "TA0004"]
    },
    "T1053.005": {
      "name": "Scheduled Task",
      "tactics": ["TA0002", "TA0003", "TA0004"]
    },
    "T1205.002": {
      "name": "Socket Filters",
      "tactics": ["TA0005", "TA0003", "TA0011"]
    },
    "T1560.001": { "name": "Archive via Utility", "tactics": ["TA0009"] },
    "T1021.005": { "name": "VNC", "tactics": ["TA0008"] },
    "T1047": {
      "name": "Windows Management Instrumentation",
      "tactics": ["TA0002"]
    },
    "T1687": {
      "name": "Exploitation for Defense Impairment",
      "tactics": ["TA0112"]
    },
    "T1113": { "name": "Screen Capture", "tactics": ["TA0009"] },
    "T1027.011": { "name": "Fileless Storage", "tactics": ["TA0005"] },
    "T1037": {
      "name": "Boot or Logon Initialization Scripts",
      "tactics": ["TA0003", "TA0004"]
    },
    "T1557": {
      "name": "Adversary-in-the-Middle",
      "tactics": ["TA0006", "TA0009"]
    },
    "T1033": { "name": "System Owner/User Discovery", "tactics": ["TA0007"] },
    "T1583": { "name": "Acquire Infrastructure", "tactics": ["TA0042"] },
    "T1218.011": { "name": "Rundll32", "tactics": ["TA0005"] },
    "T1613": {
      "name": "Container and Resource Discovery",
      "tactics": ["TA0007"]
    },
    "T1583.007": { "name": "Serverless", "tactics": ["TA0042"] },
    "T1132.001": { "name": "Standard Encoding", "tactics": ["TA0011"] },
    "T1027.009": { "name": "Embedded Payloads", "tactics": ["TA0005"] },
    "T1556.003": {
      "name": "Pluggable Authentication Modules",
      "tactics": ["TA0112", "TA0003", "TA0006"]
    },
    "T1578.004": { "name": "Revert Cloud Instance", "tactics": ["TA0112"] },
    "T1592": {
      "name": "Gather Victim Host Information",
      "tactics": ["TA0043"]
    },
    "T1596.003": { "name": "Digital Certificates", "tactics": ["TA0043"] },
    "T1056.001": { "name": "Keylogging", "tactics": ["TA0009", "TA0006"] },
    "T1564.012": { "name": "File/Path Exclusions", "tactics": ["TA0005"] },
    "T1222.002": { "name": "Linux and Mac Permissions", "tactics": ["TA0112"] },
    "T1110.001": { "name": "Password Guessing", "tactics": ["TA0006"] },
    "T1216.001": { "name": "PubPrn", "tactics": ["TA0005"] },
    "T1597.002": { "name": "Purchase Technical Data", "tactics": ["TA0043"] },
    "T1003": { "name": "OS Credential Dumping", "tactics": ["TA0006"] },
    "T1129": { "name": "Shared Modules", "tactics": ["TA0002"] },
    "T1602": {
      "name": "Data from Configuration Repository",
      "tactics": ["TA0009"]
    },
    "T1561.002": { "name": "Disk Structure Wipe", "tactics": ["TA0040"] },
    "T1498.001": { "name": "Direct Network Flood", "tactics": ["TA0040"] },
    "T1574.007": {
      "name": "Path Interception by PATH Environment Variable",
      "tactics": ["TA0005", "TA0002"]
    },
    "T1213.002": { "name": "Sharepoint", "tactics": ["TA0009"] },
    "T1006": { "name": "Direct Volume Access", "tactics": ["TA0005"] },
    "T1588.007": { "name": "Artificial Intelligence", "tactics": ["TA0042"] },
    "T1666": {
      "name": "Modify Cloud Resource Hierarchy",
      "tactics": ["TA0112"]
    },
    "T1564.008": { "name": "Email Hiding Rules", "tactics": ["TA0005"] },
    "T1491.002": { "name": "External Defacement", "tactics": ["TA0040"] },
    "T1027.013": { "name": "Encrypted/Encoded File", "tactics": ["TA0005"] },
    "T1590.005": { "name": "IP Addresses", "tactics": ["TA0043"] },
    "T1499.001": { "name": "OS Exhaustion Flood", "tactics": ["TA0040"] },
    "T1014": { "name": "Rootkit", "tactics": ["TA0005"] },
    "T1546.013": {
      "name": "PowerShell Profile",
      "tactics": ["TA0004", "TA0003"]
    },
    "T1059.007": { "name": "JavaScript", "tactics": ["TA0002"] },
    "T1685.003": { "name": "Modify or Spoof Tool UI", "tactics": ["TA0112"] },
    "T1590.002": { "name": "DNS", "tactics": ["TA0043"] },
    "T1485.001": {
      "name": "Lifecycle-Triggered Deletion",
      "tactics": ["TA0040"]
    },
    "T1123": { "name": "Audio Capture", "tactics": ["TA0009"] },
    "T1543": {
      "name": "Create or Modify System Process",
      "tactics": ["TA0003", "TA0004"]
    },
    "T1133": {
      "name": "External Remote Services",
      "tactics": ["TA0003", "TA0001"]
    },
    "T1546.006": {
      "name": "LC_LOAD_DYLIB Addition",
      "tactics": ["TA0004", "TA0003"]
    },
    "T1539": { "name": "Steal Web Session Cookie", "tactics": ["TA0006"] },
    "T1053.007": {
      "name": "Container Orchestration Job",
      "tactics": ["TA0002", "TA0003", "TA0004"]
    },
    "T1568.002": {
      "name": "Domain Generation Algorithms",
      "tactics": ["TA0011"]
    },
    "T1036.007": { "name": "Double File Extension", "tactics": ["TA0005"] },
    "T1548.002": {
      "name": "Bypass User Account Control",
      "tactics": ["TA0004"]
    },
    "T1496.003": { "name": "SMS Pumping", "tactics": ["TA0040"] },
    "T1016.001": {
      "name": "Internet Connection Discovery",
      "tactics": ["TA0007"]
    },
    "T1548.003": { "name": "Sudo and Sudo Caching", "tactics": ["TA0004"] },
    "T1685.001": {
      "name": "Disable or Modify Windows Event Log",
      "tactics": ["TA0112"]
    },
    "T1682": { "name": "Query Public AI Services", "tactics": ["TA0043"] },
    "T1560.003": { "name": "Archive via Custom Method", "tactics": ["TA0009"] },
    "T1578": {
      "name": "Modify Cloud Compute Infrastructure",
      "tactics": ["TA0112"]
    },
    "T1584.008": { "name": "Network Devices", "tactics": ["TA0042"] },
    "T1583.008": { "name": "Malvertising", "tactics": ["TA0042"] },
    "T1069": { "name": "Permission Groups Discovery", "tactics": ["TA0007"] },
    "T1114": { "name": "Email Collection", "tactics": ["TA0009"] },
    "T1003.002": { "name": "Security Account Manager", "tactics": ["TA0006"] },
    "T1596.002": { "name": "WHOIS", "tactics": ["TA0043"] },
    "T1542.001": { "name": "System Firmware", "tactics": ["TA0005", "TA0003"] },
    "T1594": { "name": "Search Victim-Owned Websites", "tactics": ["TA0043"] },
    "T1069.003": { "name": "Cloud Groups", "tactics": ["TA0007"] },
    "T1574.011": {
      "name": "Services Registry Permissions Weakness",
      "tactics": ["TA0005", "TA0002"]
    },
    "T1596.001": { "name": "DNS/Passive DNS", "tactics": ["TA0043"] },
    "T1499.003": {
      "name": "Application Exhaustion Flood",
      "tactics": ["TA0040"]
    },
    "T1195.001": {
      "name": "Compromise Software Dependencies and Development Tools",
      "tactics": ["TA0001"]
    },
    "T1588.004": { "name": "Digital Certificates", "tactics": ["TA0042"] },
    "T1583.002": { "name": "DNS Server", "tactics": ["TA0042"] },
    "T1561": { "name": "Disk Wipe", "tactics": ["TA0040"] },
    "T1071.004": { "name": "DNS", "tactics": ["TA0011"] },
    "T1552.005": {
      "name": "Cloud Instance Metadata API",
      "tactics": ["TA0006"]
    },
    "T1555.002": { "name": "Securityd Memory", "tactics": ["TA0006"] },
    "T1615": { "name": "Group Policy Discovery", "tactics": ["TA0007"] },
    "T1542.003": { "name": "Bootkit", "tactics": ["TA0005", "TA0003"] },
    "T1025": { "name": "Data from Removable Media", "tactics": ["TA0009"] },
    "T1218.013": { "name": "Mavinject", "tactics": ["TA0005"] },
    "T1074.001": { "name": "Local Data Staging", "tactics": ["TA0009"] },
    "T1036.005": {
      "name": "Match Legitimate Resource Name or Location",
      "tactics": ["TA0005"]
    },
    "T1587.003": { "name": "Digital Certificates", "tactics": ["TA0042"] },
    "T1565.001": { "name": "Stored Data Manipulation", "tactics": ["TA0040"] },
    "T1110.002": { "name": "Password Cracking", "tactics": ["TA0006"] },
    "T1114.001": { "name": "Local Email Collection", "tactics": ["TA0009"] },
    "T1555.001": { "name": "Keychain", "tactics": ["TA0006"] },
    "T1547": {
      "name": "Boot or Logon Autostart Execution",
      "tactics": ["TA0003", "TA0004"]
    },
    "T1003.004": { "name": "LSA Secrets", "tactics": ["TA0006"] },
    "T1600": { "name": "Weaken Encryption", "tactics": ["TA0112"] },
    "T1606.002": { "name": "SAML Tokens", "tactics": ["TA0006"] },
    "T1036.008": { "name": "Masquerade File Type", "tactics": ["TA0005"] },
    "T1489": { "name": "Service Stop", "tactics": ["TA0040"] },
    "T1587.001": { "name": "Malware", "tactics": ["TA0042"] },
    "T1652": { "name": "Device Driver Discovery", "tactics": ["TA0007"] },
    "T1087.002": { "name": "Domain Account", "tactics": ["TA0007"] },
    "T1547.014": { "name": "Active Setup", "tactics": ["TA0003", "TA0004"] },
    "T1564": { "name": "Hide Artifacts", "tactics": ["TA0005"] },
    "T1559.002": { "name": "Dynamic Data Exchange", "tactics": ["TA0002"] },
    "T1204.002": { "name": "Malicious File", "tactics": ["TA0002"] },
    "T1591.003": { "name": "Identify Business Tempo", "tactics": ["TA0043"] },
    "T1685.004": {
      "name": "Disable or Modify Linux Audit System Log",
      "tactics": ["TA0112"]
    },
    "T1071.005": {
      "name": "Publish/Subscribe Protocols",
      "tactics": ["TA0011"]
    },
    "T1592.001": { "name": "Hardware", "tactics": ["TA0043"] },
    "T1080": { "name": "Taint Shared Content", "tactics": ["TA0008"] },
    "T1484.002": {
      "name": "Trust Modification",
      "tactics": ["TA0112", "TA0004"]
    },
    "T1213.006": { "name": "Databases", "tactics": ["TA0009"] },
    "T1573.001": { "name": "Symmetric Cryptography", "tactics": ["TA0011"] },
    "T1087.001": { "name": "Local Account", "tactics": ["TA0007"] },
    "T1586.001": { "name": "Social Media Accounts", "tactics": ["TA0042"] },
    "T1176.001": { "name": "Browser Extensions", "tactics": ["TA0003"] },
    "T1542.005": { "name": "TFTP Boot", "tactics": ["TA0005", "TA0003"] },
    "T1686.003": { "name": "Windows Host Firewall", "tactics": ["TA0112"] },
    "T1543.003": { "name": "Windows Service", "tactics": ["TA0003", "TA0004"] },
    "T1568.001": { "name": "Fast Flux DNS", "tactics": ["TA0011"] },
    "T1497.001": { "name": "System Checks", "tactics": ["TA0005", "TA0007"] },
    "T1053.003": { "name": "Cron", "tactics": ["TA0002", "TA0003", "TA0004"] },
    "T1069.002": { "name": "Domain Groups", "tactics": ["TA0007"] },
    "T1588.006": { "name": "Vulnerabilities", "tactics": ["TA0042"] },
    "T1566.002": { "name": "Spearphishing Link", "tactics": ["TA0001"] },
    "T1499.004": {
      "name": "Application or System Exploitation",
      "tactics": ["TA0040"]
    },
    "T1137": { "name": "Office Application Startup", "tactics": ["TA0003"] },
    "T1218.004": { "name": "InstallUtil", "tactics": ["TA0005"] },
    "T1598.003": { "name": "Spearphishing Link", "tactics": ["TA0043"] },
    "T1021.004": { "name": "SSH", "tactics": ["TA0008"] },
    "T1098.003": {
      "name": "Additional Cloud Roles",
      "tactics": ["TA0003", "TA0004"]
    },
    "T1547.012": {
      "name": "Print Processors",
      "tactics": ["TA0003", "TA0004"]
    },
    "T1566.001": { "name": "Spearphishing Attachment", "tactics": ["TA0001"] },
    "T1027.008": { "name": "Stripped Payloads", "tactics": ["TA0005"] },
    "T1559.001": { "name": "Component Object Model", "tactics": ["TA0002"] },
    "T1574.001": { "name": "DLL", "tactics": ["TA0005", "TA0002"] },
    "T1119": { "name": "Automated Collection", "tactics": ["TA0009"] },
    "T1689": { "name": "Downgrade Attack", "tactics": ["TA0112"] },
    "T1115": { "name": "Clipboard Data", "tactics": ["TA0009"] },
    "T1003.007": { "name": "Proc Filesystem", "tactics": ["TA0006"] },
    "T1583.005": { "name": "Botnet", "tactics": ["TA0042"] },
    "T1555.005": { "name": "Password Managers", "tactics": ["TA0006"] },
    "T1553.001": { "name": "Gatekeeper Bypass", "tactics": ["TA0112"] },
    "T1675": { "name": "ESXi Administration Command", "tactics": ["TA0002"] },
    "T1608.004": { "name": "Drive-by Target", "tactics": ["TA0042"] },
    "T1007": { "name": "System Service Discovery", "tactics": ["TA0007"] },
    "T1040": { "name": "Network Sniffing", "tactics": ["TA0006", "TA0007"] },
    "T1553.002": { "name": "Code Signing", "tactics": ["TA0112"] },
    "T1530": { "name": "Data from Cloud Storage", "tactics": ["TA0009"] },
    "T1565.003": { "name": "Runtime Data Manipulation", "tactics": ["TA0040"] },
    "T1552.002": { "name": "Credentials in Registry", "tactics": ["TA0006"] },
    "T1135": { "name": "Network Share Discovery", "tactics": ["TA0007"] },
    "T1120": { "name": "Peripheral Device Discovery", "tactics": ["TA0007"] },
    "T1036.009": { "name": "Break Process Trees", "tactics": ["TA0005"] },
    "T1590.004": { "name": "Network Topology", "tactics": ["TA0043"] },
    "T1587.002": { "name": "Code Signing Certificates", "tactics": ["TA0042"] },
    "T1222.001": { "name": "Windows Permissions", "tactics": ["TA0112"] },
    "T1137.006": { "name": "Add-ins", "tactics": ["TA0003"] },
    "T1685.002": {
      "name": "Disable or Modify Cloud Log",
      "tactics": ["TA0112"]
    },
    "T1505.002": { "name": "Transport Agent", "tactics": ["TA0003"] },
    "T1082": { "name": "System Information Discovery", "tactics": ["TA0007"] },
    "T1071": { "name": "Application Layer Protocol", "tactics": ["TA0011"] },
    "T1574.014": {
      "name": "AppDomainManager",
      "tactics": ["TA0005", "TA0002"]
    },
    "T1074.002": { "name": "Remote Data Staging", "tactics": ["TA0009"] },
    "T1098.006": {
      "name": "Additional Container Cluster Roles",
      "tactics": ["TA0003", "TA0004"]
    },
    "T1053": {
      "name": "Scheduled Task/Job",
      "tactics": ["TA0002", "TA0003", "TA0004"]
    },
    "T1218.007": { "name": "Msiexec", "tactics": ["TA0005"] },
    "T1590.003": {
      "name": "Network Trust Dependencies",
      "tactics": ["TA0043"]
    },
    "T1498.002": { "name": "Reflection Amplification", "tactics": ["TA0040"] },
    "T1556.002": {
      "name": "Password Filter DLL",
      "tactics": ["TA0112", "TA0003", "TA0006"]
    },
    "T1505.005": { "name": "Terminal Services DLL", "tactics": ["TA0003"] },
    "T1059.002": { "name": "AppleScript", "tactics": ["TA0002"] },
    "T1176": { "name": "Software Extensions", "tactics": ["TA0003"] },
    "T1499.002": { "name": "Service Exhaustion Flood", "tactics": ["TA0040"] },
    "T1195.003": {
      "name": "Compromise Hardware Supply Chain",
      "tactics": ["TA0001"]
    },
    "T1106": { "name": "Native API", "tactics": ["TA0002"] },
    "T1558.005": { "name": "Ccache Files", "tactics": ["TA0006"] },
    "T1070.007": {
      "name": "Clear Network Connection History and Configurations",
      "tactics": ["TA0005"]
    },
    "T1558.004": { "name": "AS-REP Roasting", "tactics": ["TA0006"] },
    "T1584.003": { "name": "Virtual Private Server", "tactics": ["TA0042"] },
    "T1059.010": { "name": "AutoHotKey & AutoIT", "tactics": ["TA0002"] },
    "T1600.001": { "name": "Reduce Key Space", "tactics": ["TA0112"] },
    "T1070.003": { "name": "Clear Command History", "tactics": ["TA0005"] },
    "T1202": { "name": "Indirect Command Execution", "tactics": ["TA0005"] },
    "T1091": {
      "name": "Replication Through Removable Media",
      "tactics": ["TA0008", "TA0001"]
    },
    "T1005": { "name": "Data from Local System", "tactics": ["TA0009"] },
    "T1140": {
      "name": "Deobfuscate/Decode Files or Information",
      "tactics": ["TA0005"]
    },
    "T1137.005": { "name": "Outlook Rules", "tactics": ["TA0003"] },
    "T1586.003": { "name": "Cloud Accounts", "tactics": ["TA0042"] },
    "T1586.002": { "name": "Email Accounts", "tactics": ["TA0042"] },
    "T1098.007": {
      "name": "Additional Local or Domain Groups",
      "tactics": ["TA0003", "TA0004"]
    },
    "T1608.001": { "name": "Upload Malware", "tactics": ["TA0042"] },
    "T1195": { "name": "Supply Chain Compromise", "tactics": ["TA0001"] },
    "T1190": {
      "name": "Exploit Public-Facing Application",
      "tactics": ["TA0001"]
    },
    "T1558": {
      "name": "Steal or Forge Kerberos Tickets",
      "tactics": ["TA0006"]
    },
    "T1555": {
      "name": "Credentials from Password Stores",
      "tactics": ["TA0006"]
    },
    "T1567": { "name": "Exfiltration Over Web Service", "tactics": ["TA0010"] },
    "T1219": { "name": "Remote Access Tools", "tactics": ["TA0011"] },
    "T1583.001": { "name": "Domains", "tactics": ["TA0042"] },
    "T1560.002": { "name": "Archive via Library", "tactics": ["TA0009"] },
    "T1055.003": {
      "name": "Thread Execution Hijacking",
      "tactics": ["TA0005", "TA0004"]
    },
    "T1684": { "name": "Social Engineering", "tactics": ["TA0005"] },
    "T1036": { "name": "Masquerading", "tactics": ["TA0005"] },
    "T1546.011": {
      "name": "Application Shimming",
      "tactics": ["TA0004", "TA0003"]
    },
    "T1552": { "name": "Unsecured Credentials", "tactics": ["TA0006"] },
    "T1547.010": { "name": "Port Monitors", "tactics": ["TA0003", "TA0004"] },
    "T1070.008": { "name": "Clear Mailbox Data", "tactics": ["TA0005"] },
    "T1037.002": { "name": "Login Hook", "tactics": ["TA0003", "TA0004"] },
    "T1659": { "name": "Content Injection", "tactics": ["TA0001", "TA0011"] },
    "T1055": { "name": "Process Injection", "tactics": ["TA0005", "TA0004"] },
    "T1567.004": { "name": "Exfiltration Over Webhook", "tactics": ["TA0010"] },
    "T1205": {
      "name": "Traffic Signaling",
      "tactics": ["TA0005", "TA0003", "TA0011"]
    },
    "T1021.008": {
      "name": "Direct Cloud VM Connections",
      "tactics": ["TA0008"]
    },
    "T1218": { "name": "System Binary Proxy Execution", "tactics": ["TA0005"] },
    "T1070.006": { "name": "Timestomp", "tactics": ["TA0005"] },
    "T1557.004": { "name": "Evil Twin", "tactics": ["TA0006", "TA0009"] },
    "T1620": { "name": "Reflective Code Loading", "tactics": ["TA0005"] },
    "T1016.002": { "name": "Wi-Fi Discovery", "tactics": ["TA0007"] },
    "T1480.002": { "name": "Mutual Exclusion", "tactics": ["TA0005"] },
    "T1564.011": { "name": "Ignore Process Interrupts", "tactics": ["TA0005"] },
    "T1611": { "name": "Escape to Host", "tactics": ["TA0004"] },
    "T1518.002": { "name": "Backup Software Discovery", "tactics": ["TA0007"] },
    "T1547.009": {
      "name": "Shortcut Modification",
      "tactics": ["TA0003", "TA0004"]
    },
    "T1010": { "name": "Application Window Discovery", "tactics": ["TA0007"] },
    "T1569.003": { "name": "Systemctl", "tactics": ["TA0002"] },
    "T1087.003": { "name": "Email Account", "tactics": ["TA0007"] },
    "T1497.003": {
      "name": "Time Based Checks",
      "tactics": ["TA0005", "TA0007"]
    },
    "T1218.003": { "name": "CMSTP", "tactics": ["TA0005"] },
    "T1563.001": { "name": "SSH Hijacking", "tactics": ["TA0008"] },
    "T1029": { "name": "Scheduled Transfer", "tactics": ["TA0010"] },
    "T1021.002": { "name": "SMB/Windows Admin Shares", "tactics": ["TA0008"] },
    "T1525": { "name": "Implant Internal Image", "tactics": ["TA0003"] },
    "T1572": { "name": "Protocol Tunneling", "tactics": ["TA0011"] },
    "T1218.002": { "name": "Control Panel", "tactics": ["TA0005"] },
    "T1599.001": {
      "name": "Network Address Translation Traversal",
      "tactics": ["TA0112"]
    },
    "T1608.002": { "name": "Upload Tool", "tactics": ["TA0042"] },
    "T1547.005": {
      "name": "Security Support Provider",
      "tactics": ["TA0003", "TA0004"]
    },
    "T1036.011": {
      "name": "Overwrite Process Arguments",
      "tactics": ["TA0005"]
    },
    "T1550": {
      "name": "Use Alternate Authentication Material",
      "tactics": ["TA0008"]
    },
    "T1597.001": { "name": "Threat Intel Vendors", "tactics": ["TA0043"] },
    "T1011": {
      "name": "Exfiltration Over Other Network Medium",
      "tactics": ["TA0010"]
    },
    "T1602.002": {
      "name": "Network Device Configuration Dump",
      "tactics": ["TA0009"]
    },
    "T1589": {
      "name": "Gather Victim Identity Information",
      "tactics": ["TA0043"]
    },
    "T1560": { "name": "Archive Collected Data", "tactics": ["TA0009"] },
    "T1553.003": {
      "name": "SIP and Trust Provider Hijacking",
      "tactics": ["TA0112"]
    },
    "T1185": { "name": "Browser Session Hijacking", "tactics": ["TA0009"] },
    "T1021": { "name": "Remote Services", "tactics": ["TA0008"] },
    "T1071.003": { "name": "Mail Protocols", "tactics": ["TA0011"] },
    "T1556.007": {
      "name": "Hybrid Identity",
      "tactics": ["TA0112", "TA0003", "TA0006"]
    },
    "T1595.002": { "name": "Vulnerability Scanning", "tactics": ["TA0043"] },
    "T1059.009": { "name": "Cloud API", "tactics": ["TA0002"] },
    "T1596": {
      "name": "Search Open Technical Databases",
      "tactics": ["TA0043"]
    },
    "T1218.015": { "name": "Electron Applications", "tactics": ["TA0005"] },
    "T1207": { "name": "Rogue Domain Controller", "tactics": ["TA0112"] },
    "T1553.006": {
      "name": "Code Signing Policy Modification",
      "tactics": ["TA0112"]
    },
    "T1610": { "name": "Deploy Container", "tactics": ["TA0002"] },
    "T1112": { "name": "Modify Registry", "tactics": ["TA0112", "TA0003"] },
    "T1543.004": { "name": "Launch Daemon", "tactics": ["TA0003", "TA0004"] },
    "T1580": {
      "name": "Cloud Infrastructure Discovery",
      "tactics": ["TA0007"]
    },
    "T1555.003": {
      "name": "Credentials from Web Browsers",
      "tactics": ["TA0006"]
    },
    "T1574.008": {
      "name": "Path Interception by Search Order Hijacking",
      "tactics": ["TA0005", "TA0002"]
    },
    "T1491": { "name": "Defacement", "tactics": ["TA0040"] },
    "T1535": {
      "name": "Unused/Unsupported Cloud Regions",
      "tactics": ["TA0005"]
    },
    "T1557.003": { "name": "DHCP Spoofing", "tactics": ["TA0006", "TA0009"] },
    "T1563": {
      "name": "Remote Service Session Hijacking",
      "tactics": ["TA0008"]
    },
    "T1564.013": { "name": "Bind Mounts", "tactics": ["TA0005"] },
    "T1027.001": { "name": "Binary Padding", "tactics": ["TA0005"] },
    "T1505.003": { "name": "Web Shell", "tactics": ["TA0003"] },
    "T1484.001": {
      "name": "Group Policy Modification",
      "tactics": ["TA0112", "TA0004"]
    },
    "T1685.006": {
      "name": "Clear Linux or Mac System Logs",
      "tactics": ["TA0112"]
    },
    "T1217": { "name": "Browser Information Discovery", "tactics": ["TA0007"] },
    "T1552.004": { "name": "Private Keys", "tactics": ["TA0006"] },
    "T1583.004": { "name": "Server", "tactics": ["TA0042"] },
    "T1021.006": { "name": "Windows Remote Management", "tactics": ["TA0008"] },
    "T1011.001": {
      "name": "Exfiltration Over Bluetooth",
      "tactics": ["TA0010"]
    },
    "T1078.001": {
      "name": "Default Accounts",
      "tactics": ["TA0005", "TA0003", "TA0004", "TA0001"]
    },
    "T1547.003": { "name": "Time Providers", "tactics": ["TA0003", "TA0004"] },
    "T1546.005": { "name": "Trap", "tactics": ["TA0004", "TA0003"] },
    "T1574.006": {
      "name": "Dynamic Linker Hijacking",
      "tactics": ["TA0005", "TA0002"]
    },
    "T1136.001": { "name": "Local Account", "tactics": ["TA0003"] },
    "T1681": { "name": "Search Threat Vendor Data", "tactics": ["TA0043"] },
    "T1674": { "name": "Input Injection", "tactics": ["TA0002"] },
    "T1092": {
      "name": "Communication Through Removable Media",
      "tactics": ["TA0011"]
    },
    "T1585.002": { "name": "Email Accounts", "tactics": ["TA0042"] },
    "T1557.001": {
      "name": "Name Resolution Poisoning and SMB Relay",
      "tactics": ["TA0006", "TA0009"]
    },
    "T1222": {
      "name": "File and Directory Permissions Modification",
      "tactics": ["TA0112"]
    },
    "T1003.001": { "name": "LSASS Memory", "tactics": ["TA0006"] },
    "T1176.002": { "name": "IDE Extensions", "tactics": ["TA0003"] },
    "T1595": { "name": "Active Scanning", "tactics": ["TA0043"] },
    "T1027.016": { "name": "Junk Code Insertion", "tactics": ["TA0005"] },
    "T1548": {
      "name": "Abuse Elevation Control Mechanism",
      "tactics": ["TA0004"]
    },
    "T1134.002": {
      "name": "Create Process with Token",
      "tactics": ["TA0005", "TA0004"]
    },
    "T1548.001": { "name": "Setuid and Setgid", "tactics": ["TA0004"] },
    "T1547.004": {
      "name": "Winlogon Helper DLL",
      "tactics": ["TA0003", "TA0004"]
    },
    "T1021.003": {
      "name": "Distributed Component Object Model",
      "tactics": ["TA0008"]
    },
    "T1110.003": { "name": "Password Spraying", "tactics": ["TA0006"] },
    "T1090.002": { "name": "External Proxy", "tactics": ["TA0011"] },
    "T1056.003": {
      "name": "Web Portal Capture",
      "tactics": ["TA0009", "TA0006"]
    },
    "T1589.002": { "name": "Email Addresses", "tactics": ["TA0043"] },
    "T1598.004": { "name": "Spearphishing Voice", "tactics": ["TA0043"] },
    "T1683.001": { "name": "Written Content", "tactics": ["TA0042"] },
    "T1003.005": { "name": "Cached Domain Credentials", "tactics": ["TA0006"] },
    "T1098.004": {
      "name": "SSH Authorized Keys",
      "tactics": ["TA0003", "TA0004"]
    },
    "T1673": { "name": "Virtual Machine Discovery", "tactics": ["TA0007"] },
    "T1590.006": {
      "name": "Network Security Appliances",
      "tactics": ["TA0043"]
    },
    "T1546.012": {
      "name": "Image File Execution Options Injection",
      "tactics": ["TA0004", "TA0003"]
    },
    "T1218.008": { "name": "Odbcconf", "tactics": ["TA0005"] },
    "T1593.002": { "name": "Search Engines", "tactics": ["TA0043"] },
    "T1591.002": { "name": "Business Relationships", "tactics": ["TA0043"] },
    "T1548.005": {
      "name": "Temporary Elevated Cloud Access",
      "tactics": ["TA0004"]
    },
    "T1125": { "name": "Video Capture", "tactics": ["TA0009"] },
    "T1055.013": {
      "name": "Process Doppelgänging",
      "tactics": ["TA0005", "TA0004"]
    },
    "T1016": {
      "name": "System Network Configuration Discovery",
      "tactics": ["TA0007"]
    },
    "T1578.003": { "name": "Delete Cloud Instance", "tactics": ["TA0112"] },
    "T1593.003": { "name": "Code Repositories", "tactics": ["TA0043"] },
    "T1574.005": {
      "name": "Executable Installer File Permissions Weakness",
      "tactics": ["TA0005", "TA0002"]
    },
    "T1546.008": {
      "name": "Accessibility Features",
      "tactics": ["TA0004", "TA0003"]
    },
    "T1496.002": { "name": "Bandwidth Hijacking", "tactics": ["TA0040"] },
    "T1087": { "name": "Account Discovery", "tactics": ["TA0007"] },
    "T1090": { "name": "Proxy", "tactics": ["TA0011"] },
    "T1059": {
      "name": "Command and Scripting Interpreter",
      "tactics": ["TA0002"]
    },
    "T1204.005": { "name": "Malicious Library", "tactics": ["TA0002"] },
    "T1685.005": { "name": "Clear Windows Event Logs", "tactics": ["TA0112"] },
    "T1136.002": { "name": "Domain Account", "tactics": ["TA0003"] },
    "T1564.014": { "name": "Extended Attributes", "tactics": ["TA0005"] },
    "T1589.003": { "name": "Employee Names", "tactics": ["TA0043"] },
    "T1677": { "name": "Poisoned Pipeline Execution", "tactics": ["TA0002"] },
    "T1482": { "name": "Domain Trust Discovery", "tactics": ["TA0007"] },
    "T1558.001": { "name": "Golden Ticket", "tactics": ["TA0006"] },
    "T1020": { "name": "Automated Exfiltration", "tactics": ["TA0010"] },
    "T1592.004": { "name": "Client Configurations", "tactics": ["TA0043"] },
    "T1219.001": { "name": "IDE Tunneling", "tactics": ["TA0011"] },
    "T1036.002": { "name": "Right-to-Left Override", "tactics": ["TA0005"] },
    "T1588.001": { "name": "Malware", "tactics": ["TA0042"] },
    "T1027.017": { "name": "SVG Smuggling", "tactics": ["TA0005"] },
    "T1542.002": {
      "name": "Component Firmware",
      "tactics": ["TA0005", "TA0003"]
    },
    "T1070": { "name": "Indicator Removal", "tactics": ["TA0005"] },
    "T1048.001": {
      "name": "Exfiltration Over Symmetric Encrypted Non-C2 Protocol",
      "tactics": ["TA0010"]
    },
    "T1137.001": { "name": "Office Template Macros", "tactics": ["TA0003"] },
    "T1583.003": { "name": "Virtual Private Server", "tactics": ["TA0042"] },
    "T1213.001": { "name": "Confluence", "tactics": ["TA0009"] },
    "T1550.003": { "name": "Pass the Ticket", "tactics": ["TA0008"] },
    "T1609": {
      "name": "Container Administration Command",
      "tactics": ["TA0002"]
    },
    "T1083": { "name": "File and Directory Discovery", "tactics": ["TA0007"] },
    "T1568": { "name": "Dynamic Resolution", "tactics": ["TA0011"] },
    "T1036.004": {
      "name": "Masquerade Task or Service",
      "tactics": ["TA0005"]
    },
    "T1055.004": {
      "name": "Asynchronous Procedure Call",
      "tactics": ["TA0005", "TA0004"]
    },
    "T1020.001": { "name": "Traffic Duplication", "tactics": ["TA0010"] },
    "T1647": { "name": "Plist File Modification", "tactics": ["TA0112"] },
    "T1127.003": { "name": "JamPlus", "tactics": ["TA0005", "TA0002"] },
    "T1546.009": { "name": "AppCert DLLs", "tactics": ["TA0004", "TA0003"] },
    "T1114.003": { "name": "Email Forwarding Rule", "tactics": ["TA0009"] },
    "T1074": { "name": "Data Staged", "tactics": ["TA0009"] },
    "T1649": {
      "name": "Steal or Forge Authentication Certificates",
      "tactics": ["TA0006"]
    },
    "T1098.005": {
      "name": "Device Registration",
      "tactics": ["TA0003", "TA0004"]
    },
    "T1049": {
      "name": "System Network Connections Discovery",
      "tactics": ["TA0007"]
    },
    "T1584": { "name": "Compromise Infrastructure", "tactics": ["TA0042"] },
    "T1553.005": { "name": "Mark-of-the-Web Bypass", "tactics": ["TA0112"] },
    "T1600.002": { "name": "Disable Crypto Hardware", "tactics": ["TA0112"] },
    "T1542": { "name": "Pre-OS Boot", "tactics": ["TA0005", "TA0003"] },
    "T1612": { "name": "Build Image on Host", "tactics": ["TA0005"] },
    "T1055.002": {
      "name": "Portable Executable Injection",
      "tactics": ["TA0005", "TA0004"]
    },
    "T1218.012": { "name": "Verclsid", "tactics": ["TA0005"] },
    "T1586": { "name": "Compromise Accounts", "tactics": ["TA0042"] },
    "T1569.001": { "name": "Launchctl", "tactics": ["TA0002"] },
    "T1584.005": { "name": "Botnet", "tactics": ["TA0042"] },
    "T1059.008": { "name": "Network Device CLI", "tactics": ["TA0002"] },
    "T1552.003": { "name": "Shell History", "tactics": ["TA0006"] },
    "T1559.003": { "name": "XPC Services", "tactics": ["TA0002"] },
    "T1497": {
      "name": "Virtualization/Sandbox Evasion",
      "tactics": ["TA0005", "TA0007"]
    },
    "T1102": { "name": "Web Service", "tactics": ["TA0011"] },
    "T1552.001": { "name": "Credentials In Files", "tactics": ["TA0006"] },
    "T1568.003": { "name": "DNS Calculation", "tactics": ["TA0011"] },
    "T1218.005": { "name": "Mshta", "tactics": ["TA0005"] },
    "T1547.015": { "name": "Login Items", "tactics": ["TA0003", "TA0004"] },
    "T1608": { "name": "Stage Capabilities", "tactics": ["TA0042"] },
    "T1608.005": { "name": "Link Target", "tactics": ["TA0042"] },
    "T1104": { "name": "Multi-Stage Channels", "tactics": ["TA0011"] },
    "T1657": { "name": "Financial Theft", "tactics": ["TA0040"] },
    "T1480": { "name": "Execution Guardrails", "tactics": ["TA0005"] },
    "T1619": {
      "name": "Cloud Storage Object Discovery",
      "tactics": ["TA0007"]
    },
    "T1606.001": { "name": "Web Cookies", "tactics": ["TA0006"] },
    "T1654": { "name": "Log Enumeration", "tactics": ["TA0007"] },
    "T1134.001": {
      "name": "Token Impersonation/Theft",
      "tactics": ["TA0005", "TA0004"]
    },
    "T1567.001": {
      "name": "Exfiltration to Code Repository",
      "tactics": ["TA0010"]
    },
    "T1021.007": { "name": "Cloud Services", "tactics": ["TA0008"] },
    "T1205.001": {
      "name": "Port Knocking",
      "tactics": ["TA0005", "TA0003", "TA0011"]
    },
    "T1027.012": { "name": "LNK Icon Smuggling", "tactics": ["TA0005"] },
    "T1583.006": { "name": "Web Services", "tactics": ["TA0042"] },
    "T1528": {
      "name": "Steal Application Access Token",
      "tactics": ["TA0006"]
    },
    "T1598.002": { "name": "Spearphishing Attachment", "tactics": ["TA0043"] },
    "T1098.001": {
      "name": "Additional Cloud Credentials",
      "tactics": ["TA0003", "TA0004"]
    },
    "T1204": { "name": "User Execution", "tactics": ["TA0002"] },
    "T1491.001": { "name": "Internal Defacement", "tactics": ["TA0040"] },
    "T1564.002": { "name": "Hidden Users", "tactics": ["TA0005"] },
    "T1134.003": {
      "name": "Make and Impersonate Token",
      "tactics": ["TA0005", "TA0004"]
    },
    "T1552.006": { "name": "Group Policy Preferences", "tactics": ["TA0006"] },
    "T1048.002": {
      "name": "Exfiltration Over Asymmetric Encrypted Non-C2 Protocol",
      "tactics": ["TA0010"]
    },
    "T1087.004": { "name": "Cloud Account", "tactics": ["TA0007"] },
    "T1683.002": { "name": "Audio-Visual Content", "tactics": ["TA0042"] },
    "T1057": { "name": "Process Discovery", "tactics": ["TA0007"] },
    "T1556.008": {
      "name": "Network Provider DLL",
      "tactics": ["TA0112", "TA0003", "TA0006"]
    },
    "T1546.003": {
      "name": "Windows Management Instrumentation Event Subscription",
      "tactics": ["TA0004", "TA0003"]
    },
    "T1596.004": { "name": "CDNs", "tactics": ["TA0043"] },
    "T1497.002": {
      "name": "User Activity Based Checks",
      "tactics": ["TA0005", "TA0007"]
    },
    "T1496.004": { "name": "Cloud Service Hijacking", "tactics": ["TA0040"] },
    "T1585.003": { "name": "Cloud Accounts", "tactics": ["TA0042"] },
    "T1072": {
      "name": "Software Deployment Tools",
      "tactics": ["TA0002", "TA0008"]
    },
    "T1041": { "name": "Exfiltration Over C2 Channel", "tactics": ["TA0010"] },
    "T1134.004": {
      "name": "Parent PID Spoofing",
      "tactics": ["TA0005", "TA0004"]
    },
    "T1591": { "name": "Gather Victim Org Information", "tactics": ["TA0043"] },
    "T1606": { "name": "Forge Web Credentials", "tactics": ["TA0006"] },
    "T1621": {
      "name": "Multi-Factor Authentication Request Generation",
      "tactics": ["TA0006"]
    },
    "T1554": {
      "name": "Compromise Host Software Binary",
      "tactics": ["TA0003"]
    },
    "T1552.008": { "name": "Chat Messages", "tactics": ["TA0006"] },
    "T1059.001": { "name": "PowerShell", "tactics": ["TA0002"] },
    "T1546.001": {
      "name": "Change Default File Association",
      "tactics": ["TA0004", "TA0003"]
    },
    "T1055.014": { "name": "VDSO Hijacking", "tactics": ["TA0005", "TA0004"] },
    "T1071.002": { "name": "File Transfer Protocols", "tactics": ["TA0011"] },
    "T1679": { "name": "Selective Exclusion", "tactics": ["TA0005"] },
    "T1212": {
      "name": "Exploitation for Credential Access",
      "tactics": ["TA0006"]
    },
    "T1546.014": { "name": "Emond", "tactics": ["TA0004", "TA0003"] },
    "T1102.003": { "name": "One-Way Communication", "tactics": ["TA0011"] },
    "T1590": {
      "name": "Gather Victim Network Information",
      "tactics": ["TA0043"]
    },
    "T1210": {
      "name": "Exploitation of Remote Services",
      "tactics": ["TA0008"]
    },
    "T1534": { "name": "Internal Spearphishing", "tactics": ["TA0008"] },
    "T1574.010": {
      "name": "Services File Permissions Weakness",
      "tactics": ["TA0005", "TA0002"]
    },
    "T1547.001": {
      "name": "Registry Run Keys / Startup Folder",
      "tactics": ["TA0003", "TA0004"]
    },
    "T1199": { "name": "Trusted Relationship", "tactics": ["TA0001"] },
    "T1136.003": { "name": "Cloud Account", "tactics": ["TA0003"] },
    "T1069.001": { "name": "Local Groups", "tactics": ["TA0007"] },
    "T1593": { "name": "Search Open Websites/Domains", "tactics": ["TA0043"] },
    "T1098": {
      "name": "Account Manipulation",
      "tactics": ["TA0003", "TA0004"]
    },
    "T1048": {
      "name": "Exfiltration Over Alternative Protocol",
      "tactics": ["TA0010"]
    },
    "T1547.006": {
      "name": "Kernel Modules and Extensions",
      "tactics": ["TA0003", "TA0004"]
    },
    "T1678": { "name": "Delay Execution", "tactics": ["TA0005"] },
    "T1056.002": {
      "name": "GUI Input Capture",
      "tactics": ["TA0009", "TA0006"]
    },
    "T1686.002": { "name": "Network Device Firewall", "tactics": ["TA0112"] },
    "T1588.002": { "name": "Tool", "tactics": ["TA0042"] },
    "T1052.001": { "name": "Exfiltration over USB", "tactics": ["TA0010"] },
    "T1574.013": {
      "name": "KernelCallbackTable",
      "tactics": ["TA0005", "TA0002"]
    },
    "T1597": { "name": "Search Closed Sources", "tactics": ["TA0043"] },
    "T1053.006": {
      "name": "Systemd Timers",
      "tactics": ["TA0002", "TA0003", "TA0004"]
    },
    "T1566": { "name": "Phishing", "tactics": ["TA0001"] },
    "T1542.004": { "name": "ROMMONkit", "tactics": ["TA0005", "TA0003"] },
    "T1218.001": { "name": "Compiled HTML File", "tactics": ["TA0005"] },
    "T1496.001": { "name": "Compute Hijacking", "tactics": ["TA0040"] },
    "T1070.005": {
      "name": "Network Share Connection Removal",
      "tactics": ["TA0005"]
    },
    "T1090.003": { "name": "Multi-hop Proxy", "tactics": ["TA0011"] },
    "T1110": { "name": "Brute Force", "tactics": ["TA0006"] },
    "T1059.004": { "name": "Unix Shell", "tactics": ["TA0002"] },
    "T1137.003": { "name": "Outlook Forms", "tactics": ["TA0003"] },
    "T1219.003": { "name": "Remote Access Hardware", "tactics": ["TA0011"] },
    "T1565": { "name": "Data Manipulation", "tactics": ["TA0040"] },
    "T1559": { "name": "Inter-Process Communication", "tactics": ["TA0002"] },
    "T1001": { "name": "Data Obfuscation", "tactics": ["TA0011"] },
    "T1039": {
      "name": "Data from Network Shared Drive",
      "tactics": ["TA0009"]
    },
    "T1584.006": { "name": "Web Services", "tactics": ["TA0042"] },
    "T1601": { "name": "Modify System Image", "tactics": ["TA0112"] },
    "T1574": {
      "name": "Hijack Execution Flow",
      "tactics": ["TA0005", "TA0002"]
    },
    "T1036.012": { "name": "Browser Fingerprint", "tactics": ["TA0005"] },
    "T1059.011": { "name": "Lua", "tactics": ["TA0002"] },
    "T1027.005": {
      "name": "Indicator Removal from Tools",
      "tactics": ["TA0005"]
    },
    "T1204.003": { "name": "Malicious Image", "tactics": ["TA0002"] },
    "T1543.005": {
      "name": "Container Service",
      "tactics": ["TA0003", "TA0004"]
    },
    "T1078": {
      "name": "Valid Accounts",
      "tactics": ["TA0005", "TA0003", "TA0004", "TA0001"]
    },
    "T1571": { "name": "Non-Standard Port", "tactics": ["TA0011"] },
    "T1585.001": { "name": "Social Media Accounts", "tactics": ["TA0042"] },
    "T1055.012": {
      "name": "Process Hollowing",
      "tactics": ["TA0005", "TA0004"]
    },
    "T1068": {
      "name": "Exploitation for Privilege Escalation",
      "tactics": ["TA0004"]
    },
    "T1564.009": { "name": "Resource Forking", "tactics": ["TA0005"] },
    "T1531": { "name": "Account Access Removal", "tactics": ["TA0040"] },
    "T1110.004": { "name": "Credential Stuffing", "tactics": ["TA0006"] },
    "T1027": {
      "name": "Obfuscated Files or Information",
      "tactics": ["TA0005"]
    },
    "T1556.006": {
      "name": "Multi-Factor Authentication",
      "tactics": ["TA0112", "TA0003", "TA0006"]
    },
    "T1114.002": { "name": "Remote Email Collection", "tactics": ["TA0009"] },
    "T1505.004": { "name": "IIS Components", "tactics": ["TA0003"] },
    "T1036.001": { "name": "Invalid Code Signature", "tactics": ["TA0005"] },
    "T1683": { "name": "Generate Content", "tactics": ["TA0042"] },
    "T1564.006": { "name": "Run Virtual Instance", "tactics": ["TA0005"] },
    "T1027.014": { "name": "Polymorphic Code", "tactics": ["TA0005"] },
    "T1201": { "name": "Password Policy Discovery", "tactics": ["TA0007"] },
    "T1546": {
      "name": "Event Triggered Execution",
      "tactics": ["TA0004", "TA0003"]
    },
    "T1546.004": {
      "name": "Unix Shell Configuration Modification",
      "tactics": ["TA0004", "TA0003"]
    },
    "T1187": { "name": "Forced Authentication", "tactics": ["TA0006"] },
    "T1134.005": {
      "name": "SID-History Injection",
      "tactics": ["TA0005", "TA0004"]
    },
    "T1599": { "name": "Network Boundary Bridging", "tactics": ["TA0112"] },
    "T1486": { "name": "Data Encrypted for Impact", "tactics": ["TA0040"] },
    "T1690": {
      "name": "Prevent Command History Logging",
      "tactics": ["TA0112"]
    },
    "T1553": { "name": "Subvert Trust Controls", "tactics": ["TA0112"] },
    "T1548.004": {
      "name": "Elevated Execution with Prompt",
      "tactics": ["TA0004"]
    },
    "T1592.003": { "name": "Firmware", "tactics": ["TA0043"] },
    "T1573": { "name": "Encrypted Channel", "tactics": ["TA0011"] },
    "T1547.002": {
      "name": "Authentication Package",
      "tactics": ["TA0003", "TA0004"]
    },
    "T1218.010": { "name": "Regsvr32", "tactics": ["TA0005"] },
    "T1567.003": {
      "name": "Exfiltration to Text Storage Sites",
      "tactics": ["TA0010"]
    },
    "T1592.002": { "name": "Software", "tactics": ["TA0043"] },
    "T1056": { "name": "Input Capture", "tactics": ["TA0009", "TA0006"] },
    "T1566.004": { "name": "Spearphishing Voice", "tactics": ["TA0001"] },
    "T1587.004": { "name": "Exploits", "tactics": ["TA0042"] },
    "T1685": { "name": "Disable or Modify Tools", "tactics": ["TA0112"] },
    "T1593.001": { "name": "Social Media", "tactics": ["TA0043"] },
    "T1213.004": {
      "name": "Customer Relationship Management Software",
      "tactics": ["TA0009"]
    },
    "T1546.015": {
      "name": "Component Object Model Hijacking",
      "tactics": ["TA0004", "TA0003"]
    },
    "T1589.001": { "name": "Credentials", "tactics": ["TA0043"] },
    "T1195.002": {
      "name": "Compromise Software Supply Chain",
      "tactics": ["TA0001"]
    },
    "T1036.003": {
      "name": "Rename Legitimate Utilities",
      "tactics": ["TA0005"]
    },
    "T1102.002": {
      "name": "Bidirectional Communication",
      "tactics": ["TA0011"]
    },
    "T1203": {
      "name": "Exploitation for Client Execution",
      "tactics": ["TA0002"]
    },
    "T1595.003": { "name": "Wordlist Scanning", "tactics": ["TA0043"] },
    "T1667": { "name": "Email Bombing", "tactics": ["TA0040"] },
    "T1137.004": { "name": "Outlook Home Page", "tactics": ["TA0003"] },
    "T1573.002": { "name": "Asymmetric Cryptography", "tactics": ["TA0011"] },
    "T1567.002": {
      "name": "Exfiltration to Cloud Storage",
      "tactics": ["TA0010"]
    },
    "T1570": { "name": "Lateral Tool Transfer", "tactics": ["TA0008"] },
    "T1574.009": {
      "name": "Path Interception by Unquoted Path",
      "tactics": ["TA0005", "TA0002"]
    },
    "T1608.003": {
      "name": "Install Digital Certificate",
      "tactics": ["TA0042"]
    },
    "T1037.005": { "name": "Startup Items", "tactics": ["TA0003", "TA0004"] },
    "T1614.001": { "name": "System Language Discovery", "tactics": ["TA0007"] },
    "T1095": {
      "name": "Non-Application Layer Protocol",
      "tactics": ["TA0011"]
    },
    "T1059.013": { "name": "Container CLI/API", "tactics": ["TA0002"] },
    "T1027.003": { "name": "Steganography", "tactics": ["TA0005"] },
    "T1584.002": { "name": "DNS Server", "tactics": ["TA0042"] },
    "T1671": { "name": "Cloud Application Integration", "tactics": ["TA0003"] },
    "T1001.003": {
      "name": "Protocol or Service Impersonation",
      "tactics": ["TA0011"]
    },
    "T1012": { "name": "Query Registry", "tactics": ["TA0007"] },
    "T1030": { "name": "Data Transfer Size Limits", "tactics": ["TA0010"] },
    "T1550.004": { "name": "Web Session Cookie", "tactics": ["TA0008"] },
    "T1078.002": {
      "name": "Domain Accounts",
      "tactics": ["TA0005", "TA0003", "TA0004", "TA0001"]
    },
    "T1218.009": { "name": "Regsvcs/Regasm", "tactics": ["TA0005"] },
    "T1546.018": {
      "name": "Python Startup Hooks",
      "tactics": ["TA0003", "TA0004"]
    },
    "T1553.004": { "name": "Install Root Certificate", "tactics": ["TA0112"] },
    "T1037.003": {
      "name": "Network Logon Script",
      "tactics": ["TA0003", "TA0004"]
    },
    "T1499": { "name": "Endpoint Denial of Service", "tactics": ["TA0040"] },
    "T1027.004": { "name": "Compile After Delivery", "tactics": ["TA0005"] },
    "T1688": { "name": "Safe Mode Boot", "tactics": ["TA0112"] },
    "T1614": { "name": "System Location Discovery", "tactics": ["TA0007"] },
    "T1564.007": { "name": "VBA Stomping", "tactics": ["TA0005"] },
    "T1197": { "name": "BITS Jobs", "tactics": ["TA0005", "TA0003", "TA0002"] },
    "T1127.001": { "name": "MSBuild", "tactics": ["TA0005", "TA0002"] },
    "T1578.005": {
      "name": "Modify Cloud Compute Configurations",
      "tactics": ["TA0112"]
    },
    "T1090.004": { "name": "Domain Fronting", "tactics": ["TA0011"] },
    "T1557.002": {
      "name": "ARP Cache Poisoning",
      "tactics": ["TA0006", "TA0009"]
    },
    "T1518.001": {
      "name": "Security Software Discovery",
      "tactics": ["TA0007"]
    },
    "T1564.003": { "name": "Hidden Window", "tactics": ["TA0005"] },
    "T1127.002": { "name": "ClickOnce", "tactics": ["TA0005", "TA0002"] },
    "T1059.006": { "name": "Python", "tactics": ["TA0002"] },
    "T1070.010": { "name": "Relocate Malware", "tactics": ["TA0005"] },
    "T1591.004": { "name": "Identify Roles", "tactics": ["TA0043"] },
    "T1132": { "name": "Data Encoding", "tactics": ["TA0011"] },
    "T1546.010": { "name": "AppInit DLLs", "tactics": ["TA0004", "TA0003"] },
    "T1598": { "name": "Phishing for Information", "tactics": ["TA0043"] },
    "T1496": { "name": "Resource Hijacking", "tactics": ["TA0040"] },
    "T1684.001": { "name": "Impersonation", "tactics": ["TA0005"] },
    "T1585": { "name": "Establish Accounts", "tactics": ["TA0042"] },
    "T1588": { "name": "Obtain Capabilities", "tactics": ["TA0042"] },
    "T1546.002": { "name": "Screensaver", "tactics": ["TA0004", "TA0003"] },
    "T1556.009": {
      "name": "Conditional Access Policies",
      "tactics": ["TA0112", "TA0003", "TA0006"]
    },
    "T1578.002": { "name": "Create Cloud Instance", "tactics": ["TA0112"] },
    "T1555.006": {
      "name": "Cloud Secrets Management Stores",
      "tactics": ["TA0006"]
    },
    "T1213.003": { "name": "Code Repositories", "tactics": ["TA0009"] },
    "T1565.002": {
      "name": "Transmitted Data Manipulation",
      "tactics": ["TA0040"]
    },
    "T1003.008": {
      "name": "/etc/passwd and /etc/shadow",
      "tactics": ["TA0006"]
    },
    "T1543.001": { "name": "Launch Agent", "tactics": ["TA0003", "TA0004"] },
    "T1569": { "name": "System Services", "tactics": ["TA0002"] },
    "T1059.003": { "name": "Windows Command Shell", "tactics": ["TA0002"] },
    "T1055.009": { "name": "Proc Memory", "tactics": ["TA0005", "TA0004"] },
    "T1650": { "name": "Acquire Access", "tactics": ["TA0042"] },
    "T1601.001": { "name": "Patch System Image", "tactics": ["TA0112"] },
    "T1558.002": { "name": "Silver Ticket", "tactics": ["TA0006"] },
    "T1213": {
      "name": "Data from Information Repositories",
      "tactics": ["TA0009"]
    },
    "T1070.009": { "name": "Clear Persistence", "tactics": ["TA0005"] },
    "T1059.012": { "name": "Hypervisor CLI", "tactics": ["TA0002"] },
    "T1555.004": {
      "name": "Windows Credential Manager",
      "tactics": ["TA0006"]
    },
    "T1036.010": { "name": "Masquerade Account Name", "tactics": ["TA0005"] },
    "T1200": { "name": "Hardware Additions", "tactics": ["TA0001"] },
    "T1219.002": { "name": "Remote Desktop Software", "tactics": ["TA0011"] },
    "T1505": { "name": "Server Software Component", "tactics": ["TA0003"] },
    "T1485": { "name": "Data Destruction", "tactics": ["TA0040"] },
    "T1132.002": { "name": "Non-Standard Encoding", "tactics": ["TA0011"] },
    "T1556.001": {
      "name": "Domain Controller Authentication",
      "tactics": ["TA0112", "TA0003", "TA0006"]
    },
    "T1537": {
      "name": "Transfer Data to Cloud Account",
      "tactics": ["TA0010"]
    },
    "T1027.006": { "name": "HTML Smuggling", "tactics": ["TA0005"] },
    "T1556.005": {
      "name": "Reversible Encryption",
      "tactics": ["TA0112", "TA0003", "TA0006"]
    },
    "T1027.010": { "name": "Command Obfuscation", "tactics": ["TA0005"] },
    "T1070.004": { "name": "File Deletion", "tactics": ["TA0005"] },
    "T1189": { "name": "Drive-by Compromise", "tactics": ["TA0001"] },
    "T1498": { "name": "Network Denial of Service", "tactics": ["TA0040"] },
    "T1651": { "name": "Cloud Administration Command", "tactics": ["TA0002"] },
    "T1546.016": {
      "name": "Installer Packages",
      "tactics": ["TA0004", "TA0003"]
    },
    "T1595.001": { "name": "Scanning IP Blocks", "tactics": ["TA0043"] },
    "T1221": { "name": "Template Injection", "tactics": ["TA0005"] },
    "T1037.004": { "name": "RC Scripts", "tactics": ["TA0003", "TA0004"] },
    "T1134": {
      "name": "Access Token Manipulation",
      "tactics": ["TA0005", "TA0004"]
    },
    "T1111": {
      "name": "Multi-Factor Authentication Interception",
      "tactics": ["TA0006"]
    },
    "T1027.002": { "name": "Software Packing", "tactics": ["TA0005"] },
    "T1584.007": { "name": "Serverless", "tactics": ["TA0042"] },
    "T1071.001": { "name": "Web Protocols", "tactics": ["TA0011"] },
    "T1059.005": { "name": "Visual Basic", "tactics": ["TA0002"] },
    "T1564.005": { "name": "Hidden File System", "tactics": ["TA0005"] },
    "T1543.002": { "name": "Systemd Service", "tactics": ["TA0003", "TA0004"] },
    "T1668": { "name": "Exclusive Control", "tactics": ["TA0003"] },
    "T1563.002": { "name": "RDP Hijacking", "tactics": ["TA0008"] },
    "T1136": { "name": "Create Account", "tactics": ["TA0003"] },
    "T1547.013": {
      "name": "XDG Autostart Entries",
      "tactics": ["TA0003", "TA0004"]
    },
    "T1584.004": { "name": "Server", "tactics": ["TA0042"] },
    "T1526": { "name": "Cloud Service Discovery", "tactics": ["TA0007"] },
    "T1204.004": { "name": "Malicious Copy and Paste", "tactics": ["TA0002"] },
    "T1018": { "name": "Remote System Discovery", "tactics": ["TA0007"] },
    "T1046": { "name": "Network Service Discovery", "tactics": ["TA0007"] },
    "T1590.001": { "name": "Domain Properties", "tactics": ["TA0043"] },
    "T1518": { "name": "Software Discovery", "tactics": ["TA0007"] },
    "T1538": { "name": "Cloud Service Dashboard", "tactics": ["TA0007"] },
    "T1055.005": {
      "name": "Thread Local Storage",
      "tactics": ["TA0005", "TA0004"]
    },
    "T1622": { "name": "Debugger Evasion", "tactics": ["TA0005", "TA0007"] },
    "T1036.006": { "name": "Space after Filename", "tactics": ["TA0005"] },
    "T1547.007": {
      "name": "Re-opened Applications",
      "tactics": ["TA0003", "TA0004"]
    },
    "T1608.006": { "name": "SEO Poisoning", "tactics": ["TA0042"] },
    "T1550.002": { "name": "Pass the Hash", "tactics": ["TA0008"] },
    "T1052": {
      "name": "Exfiltration Over Physical Medium",
      "tactics": ["TA0010"]
    },
    "T1105": { "name": "Ingress Tool Transfer", "tactics": ["TA0011"] },
    "T1216.002": { "name": "SyncAppvPublishingServer", "tactics": ["TA0005"] },
    "T1098.002": {
      "name": "Additional Email Delegate Permissions",
      "tactics": ["TA0003", "TA0004"]
    },
    "T1588.003": { "name": "Code Signing Certificates", "tactics": ["TA0042"] },
    "T1648": { "name": "Serverless Execution", "tactics": ["TA0002"] },
    "T1548.006": { "name": "TCC Manipulation", "tactics": ["TA0004"] },
    "T1027.018": { "name": "Invisible Unicode", "tactics": ["TA0005"] },
    "T1055.008": {
      "name": "Ptrace System Calls",
      "tactics": ["TA0005", "TA0004"]
    },
    "T1653": { "name": "Power Settings", "tactics": ["TA0003"] },
    "T1027.007": { "name": "Dynamic API Resolution", "tactics": ["TA0005"] },
    "T1021.001": { "name": "Remote Desktop Protocol", "tactics": ["TA0008"] },
    "T1037.001": {
      "name": "Logon Script (Windows)",
      "tactics": ["TA0003", "TA0004"]
    },
    "T1055.015": { "name": "ListPlanting", "tactics": ["TA0005", "TA0004"] },
    "T1665": { "name": "Hide Infrastructure", "tactics": ["TA0011"] },
    "T1484": {
      "name": "Domain or Tenant Policy Modification",
      "tactics": ["TA0112", "TA0004"]
    },
    "T1220": { "name": "XSL Script Processing", "tactics": ["TA0005"] },
    "T1596.005": { "name": "Scan Databases", "tactics": ["TA0043"] },
    "T1564.001": {
      "name": "Hidden Files and Directories",
      "tactics": ["TA0005"]
    },
    "T1578.001": { "name": "Create Snapshot", "tactics": ["TA0112"] },
    "T1591.001": {
      "name": "Determine Physical Locations",
      "tactics": ["TA0043"]
    },
    "T1137.002": { "name": "Office Test", "tactics": ["TA0003"] },
    "T1587": { "name": "Develop Capabilities", "tactics": ["TA0042"] },
    "T1003.003": { "name": "NTDS", "tactics": ["TA0006"] },
    "T1686.001": { "name": "Cloud Firewall", "tactics": ["TA0112"] },
    "T1602.001": { "name": "SNMP (MIB Dump)", "tactics": ["TA0009"] },
    "T1686": {
      "name": "Disable or Modify System Firewall",
      "tactics": ["TA0112"]
    },
    "T1001.002": { "name": "Steganography", "tactics": ["TA0011"] },
    "T1204.001": { "name": "Malicious Link", "tactics": ["TA0002"] },
    "T1550.001": { "name": "Application Access Token", "tactics": ["TA0008"] },
    "T1547.008": { "name": "LSASS Driver", "tactics": ["TA0003", "TA0004"] },
    "T1569.002": { "name": "Service Execution", "tactics": ["TA0002"] },
    "T1078.004": {
      "name": "Cloud Accounts",
      "tactics": ["TA0005", "TA0003", "TA0004", "TA0001"]
    },
    "T1480.001": { "name": "Environmental Keying", "tactics": ["TA0005"] },
    "T1008": { "name": "Fallback Channels", "tactics": ["TA0011"] },
    "T1680": { "name": "Local Storage Discovery", "tactics": ["TA0007"] },
    "T1564.004": { "name": "NTFS File Attributes", "tactics": ["TA0005"] },
    "T1558.003": { "name": "Kerberoasting", "tactics": ["TA0006"] },
    "T1003.006": { "name": "DCSync", "tactics": ["TA0006"] },
    "T1124": { "name": "System Time Discovery", "tactics": ["TA0007"] },
    "T1053.002": { "name": "At", "tactics": ["TA0002", "TA0003", "TA0004"] },
    "T1055.001": {
      "name": "Dynamic-link Library Injection",
      "tactics": ["TA0005", "TA0004"]
    },
    "T1588.005": { "name": "Exploits", "tactics": ["TA0042"] },
    "T1556": {
      "name": "Modify Authentication Process",
      "tactics": ["TA0112", "TA0003", "TA0006"]
    },
    "T1546.017": { "name": "Udev Rules", "tactics": ["TA0003", "TA0004"] },
    "T1056.004": {
      "name": "Credential API Hooking",
      "tactics": ["TA0009", "TA0006"]
    },
    "T1495": { "name": "Firmware Corruption", "tactics": ["TA0040"] },
    "T1490": { "name": "Inhibit System Recovery", "tactics": ["TA0040"] },
    "T1546.007": {
      "name": "Netsh Helper DLL",
      "tactics": ["TA0004", "TA0003"]
    },
    "T1566.003": { "name": "Spearphishing via Service", "tactics": ["TA0001"] },
    "T1090.001": { "name": "Internal Proxy", "tactics": ["TA0011"] },
    "T1216": { "name": "System Script Proxy Execution", "tactics": ["TA0005"] },
    "T1102.001": { "name": "Dead Drop Resolver", "tactics": ["TA0011"] },
    "T1001.001": { "name": "Junk Data", "tactics": ["TA0011"] },
    "T1598.001": { "name": "Spearphishing Service", "tactics": ["TA0043"] },
    "T1505.006": {
      "name": "vSphere Installation Bundles",
      "tactics": ["TA0003"]
    },
    "T1552.007": { "name": "Container API", "tactics": ["TA0006"] },
    "T1584.001": { "name": "Domains", "tactics": ["TA0042"] },
    "T1505.001": { "name": "SQL Stored Procedures", "tactics": ["TA0003"] },
    "T1556.004": {
      "name": "Network Device Authentication",
      "tactics": ["TA0112", "TA0003", "TA0006"]
    },
    "T1561.001": { "name": "Disk Content Wipe", "tactics": ["TA0040"] },
    "T1213.005": { "name": "Messaging Applications", "tactics": ["TA0009"] },
    "T1048.003": {
      "name": "Exfiltration Over Unencrypted Non-C2 Protocol",
      "tactics": ["TA0010"]
    },
    "T1027.015": { "name": "Compression", "tactics": ["TA0005"] },
    "T1574.004": { "name": "Dylib Hijacking", "tactics": ["TA0005", "TA0002"] },
    "T1601.002": { "name": "Downgrade System Image", "tactics": ["TA0112"] },
    "T1684.002": { "name": "Email Spoofing", "tactics": ["TA0005"] },
    "T1078.003": {
      "name": "Local Accounts",
      "tactics": ["TA0005", "TA0003", "TA0004", "TA0001"]
    },
    "T1669": { "name": "Wi-Fi Networks", "tactics": ["TA0001"] },
    "T1211": { "name": "Exploitation for Stealth", "tactics": ["TA0005"] },
    "T1127": {
      "name": "Trusted Developer Utilities Proxy Execution",
      "tactics": ["TA0005", "TA0002"]
    },
    "T1529": { "name": "System Shutdown/Reboot", "tactics": ["TA0040"] },
    "T1218.014": { "name": "MMC", "tactics": ["TA0005"] },
    "T1564.010": { "name": "Process Argument Spoofing", "tactics": ["TA0005"] },
    "T1574.012": { "name": "COR_PROFILER", "tactics": ["TA0005", "TA0002"] }
  }
}
